import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { WINDOW_TOKEN } from '@usana/ux/common';
import { UrlService } from '@usana/ux/common/url';
import { first } from 'rxjs/operators';

@Component({
    selector: 'sso-redirect',
    template: '',
    styleUrls: [],
    standalone: false
})
export class RedirectComponent implements OnInit {
  constructor(
    private readonly urlService: UrlService,
    private readonly activatedRoute: ActivatedRoute,
    @Inject(WINDOW_TOKEN) private readonly window: Window
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap
      .pipe(first()) // only the first
      .subscribe((queryParams: ParamMap) => {
        this.window.open(
          `${this.urlService.getDomainWithSubdomain(queryParams.get('subdomain') || 'www')}${
            queryParams.get('uri') || '/ux/dotcom/'
          }`,
          '_self'
        );
      });
  }
}
